import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Insertdecision } from './insertdecision';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { AppComponent } from '../app.component';
import { DatePipe } from '@angular/common';

import { AlertService } from '../alertpopup/_alert';
import { error } from 'console';
import { InsertChequeBouncingData } from '../notice/generate-notice/InsertChequeBouncingData';

declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface fillingOppositeParty {
  ID: string;
  Name: string;
  Mobile: string;
  State: string;
  City: string;
  typ: string;
}
export interface INoticeProduct {
  ID: number;
  Remarks: string;
  ProductName: string;
  ProductCode: string;
  ProductID: string;
}
export interface IConvertCaseNotice {
  ID: number;
  refno: string;
  Date: string;
  Status: string;
}
export interface Section {
  hdID: string;
  MainDescr: string;
}
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-corporate-decision',
  templateUrl: './corporate-decision.component.html',
  styleUrls: ['./corporate-decision.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: false
})
export class CorporateDecisionComponent implements OnInit {
  TypeHeader: string;
  Type: string;
  id: any;
  Category: any;
  SubCategory: any;
  Company: any;
  Department: any;
  Designation: any;
  Agency: any;
  Manager: any;
  Leader: any;
  User: any;
  State: any;
  City: any;
  Currency: any;
  Jurisdiction: any;
  Status: any;
  Seriousness: any;
  url: string;
  pageurl: string;
  RefNo: string;
  addFormDecision: FormGroup;
  FormAddNoticeCaseorClosed: FormGroup;
  getdata: string;
  numb: any;
  DueDate: string;
  DateofDecision: string;
  LastDate: string;
  TargetDate: string;
  str: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  NoticeCaseData: any;
  factsheetDetail: any;
  FetchContactRecord: any;
  modalURL: string;
  CallFunctionOnCloseModal: any;
  fetchfollowupData: any;
  fetchNoticeHistoryData: any;
  expenseDetail: any;
  DisplayExistNotice: string;
  FillingOppoParty: fillingOppositeParty[] = [];
  filteredFillingParty: fillingOppositeParty[] = [];
  filteredOppositeParty: fillingOppositeParty[] = [];
  ContactList: fillingOppositeParty[] = [];
  SectionList: Section[] = [];
  ProductHelpList: Section[] = [];
  selectedProduct = [];
  selectedFillingParty = [];
  selectedOppositeParty = [];
  DisplaySaveNoticeButton: string;
  FetchExistingFillingParty: any;
  FetchExistingOppositeParty: any;
  HeaderButtonCaption: string;
  ModelFor: string;
  NoticeProductData: INoticeProduct[] = [];
  editable: boolean;
  clicked: boolean;
  DownloadURL: string;
  statusNo: any;
  HideCaseNotice: string;
  HideClosed: string;
  HideStatus: string;
  CaptionLabel: string;
  fileSize: string;
  fileName: string;
  fileurls = [];
  OutputValue: any;
  HideButtonSubmit: string;
  HeaderButtonCaptionValue: number;
  RightsID: string;
  RouteGMAgency: string;
  RouteGMCategory: string;
  RouteGMSubCategory: string;
  RouteGMDepartment: string;
  RouteGMState: string;
  RouteGMProduct: string;
  RouteGMCurrency: string;
  RouteGMCity: string;
  RouteGMJurisdiction: string;
  RouteUserMaster: string;
  RouteCompany: string;
  AddFollowupLink: string;
  ManagerPreID: any;
  LeaderPreID: any;
  PageStatus: string;
  RouteGMRegion: string;
  RouteGMBranch: string;
  CommunityRights: string;
  CommunityDisplayRegionBranch: string;
  Region: string;
  Branch: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  loading: boolean = false;
  factsheetDetailsError: boolean = false;
  fetchNoticeHistoryDataError: boolean;
  filteredData: any[] = [];
  ChequeBouncingForm: FormGroup;
  AmountDue: any;
  ReceivingAmount: any;
  againstchequebouncing: any;
  Captions: any = {};
  typeOfAction: any;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.CommunityRights = localStorage.getItem('CommunityRights');
    if (this.CommunityRights.includes('202016000')) { this.CommunityDisplayRegionBranch = "1"; }
    if (this.RightsID.includes('202038001') || this.RightsID.includes('202038021') || this.RightsID.includes('202038000')) {
    } else {
      window.location.href = "module/0";
    }
    this.getCaptionData();
    this.getMasterData();
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    this.DisplaySaveNoticeButton = "submit";
    this.HeaderButtonCaption = "Create";
    this.HideStatus = "!isHidden";
    this.CaptionLabel = "";
    this.OutputValue = "";
    this.HideButtonSubmit = "";
    this.HideClosed = "!isHidden";
    this.HeaderButtonCaptionValue = 0;
    this.clicked = false;
    if (this.id > 0) {
      this.HideStatus = "";
      this.DisplaySaveNoticeButton = "submit";
      this.fetchNoticeCaseData();
      this.AttachmentData();
      this.FetchDescisionHistory();
    }

    // Set Validation of Add Notice / Case Form on Header Part
    this.addFormDecision = this.formBuilder.group({
      Agency: ['', Validators.required], Description: ['', Validators.required], browseFiles: [''], Manager: ['', Validators.required], Category: ['', Validators.required], SubCategory: ['', Validators.required],
      Company: ['', Validators.required], Department: ['', Validators.required], ExposureAmmount: ['', Validators.required], State: ['', Validators.required], Leader: ['', Validators.required], TargetDate: ['', Validators.required],
      City: ['', Validators.required], Status: ['', Validators.required], Jurisdiction: ['', Validators.required], DueDate: [''], DateofDecision: ['', Validators.required], reason: [''], fillingPartyName: ['', Validators.required], oppositePartyName: ['', Validators.required],
      BriefFacts: ['', Validators.required], ActionType: ['', Validators.required], ActionTakenBy: ['', Validators.required], HelpProduct: ['', Validators.required], Currency: ['', Validators.required], Region: ['', Validators.required], Branch: ['', Validators.required]
    });
    this.FormAddNoticeCaseorClosed = this.formBuilder.group({
      Date: ['', Validators.required], refno: ['', Validators.required]
    });
    this.ChequeBouncingForm = this.formBuilder.group({
      AmountDue: [null, Validators.required], DateofReceivingAmount: [null, Validators.required], ReceivingAmount: [null,Validators.required], ModeOfPayment: [null, Validators.required], againstchequebouncing: [{ value: null, disabled: true }],
      TotalOSFromParty: [null, Validators.required], ChequeDate: [null, Validators.required], ChequeNo: [null, Validators.required], ChequeAmount: [null, Validators.required], DishonorDate: [null, Validators.required], DishonorReason: [null,Validators.required],
      DishonorBank: [null,Validators.required], DishonorBankBranch: [null, Validators.required]
    });
    // Set By Default Value on Header Part
    // this.addFormDecision.patchValue({
    //   State: "0", Agency: "0", Manager: "0", Category: "0", SubCategory: "0", Company: "0", Department: "0",
    //   Leader: "0", City: "0", Status: "0", Jurisdiction: "0", Currency: "0", Region: '0', Branch: '0'
    // });
    this.fetchRouteDataRights();
    // React to changes
    this.addFormDecision.get('fillingPartyName')?.valueChanges.subscribe(val => {
      this.selectedFillingParty = val || [];
      this.updateFilters();
    });

    this.addFormDecision.get('oppositePartyName')?.valueChanges.subscribe(val => {
      this.selectedOppositeParty = val || [];
      this.updateFilters();
    });
  }
  getCaptionData(): void {
    this.http.get<any>(`${this.url}Dashboard/CaptionData?id=`).subscribe({
      next: (res) => {
        const data = typeof res === 'string' ? JSON.parse(res) : res;

        const filtered = data.filter((x: any) => x.MainId === "5");

        filtered.forEach((element: any) => {
          const key = element?.SubDescr
          ?.replace(/\s+/g, '_')
          ?.replace(/[\/()]/g, '')
          ?.replace(/_+/g, '_')
          ?.trim().toLowerCase();
          if (key) {
            this.Captions[key] = element.SelectedValue;
          }
        });
      },
      error: (err) => {
        console.error('Error fetching caption data', err);
      }
    });
  }

  fetchRouteDataRights() {
    // tslint:disable-next-line: max-line-length
    this.RouteCompany = this.RightsID.includes('202044000') || this.RightsID.includes('202044001') || this.RightsID.includes('202044021') ? '/navcompany/company/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? '/user-master' : '/module/0';
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
      this.RouteGMAgency = "/general-master/040";
      this.RouteGMCategory = "/general-master/045";
      this.RouteGMSubCategory = "/general-master/050";
      this.RouteGMDepartment = "/general-master/030";
      this.RouteGMState = "/general-master/010";
      this.RouteGMProduct = "/general-master/075";
      this.RouteGMCurrency = "/general-master/115";
      this.RouteGMCity = "/general-master/015";
      this.RouteGMJurisdiction = "/general-master/020";
      this.RouteGMRegion = "/general-master/085";
      this.RouteGMBranch = "/general-master/090";
    } else {
      this.RouteGMRegion = "/module/0";
      this.RouteGMBranch = "/module/0";
      this.RouteGMAgency = "/module/0";
      this.RouteGMCategory = "/module/0";
      this.RouteGMSubCategory = "/module/0";
      this.RouteGMDepartment = "/module/0";
      this.RouteGMState = "/module/0";
      this.RouteGMProduct = "/module/0";
      this.RouteGMCurrency = "/module/0";
      this.RouteGMCity = "/module/0";
      this.RouteGMJurisdiction = "/module/0";
    }
  }
  // function f() for display validation on header part
  get f() { return this.addFormDecision.controls; }
  onStateSelect(value: any) {
    this.getMaster('015', value.hdID).subscribe((data: any) => {
      this.City = data;
      let data1: any;
      this.Jurisdiction = data1;
    });
    this.addFormDecision.patchValue({ City: '0', Jurisdiction: '0' });
  }
  onRegionSelect(value: any) {
    this.getMaster('090', value.hdID).subscribe((data: any) => { this.Branch = data; });
  }
  onCitySelect(value: any) {
    this.getMaster('020', value.hdID).subscribe((data: any) => {
      this.Jurisdiction = data;
      this.addFormDecision.patchValue({ Jurisdiction: '0' });
    });
  }
  onCategorySelect(value: any) {
    this.getMaster('050', value.hdID).subscribe((data: any) => {
      this.SubCategory = data;
      this.addFormDecision.patchValue({ SubCategory: '0' });
    });
  }
  onStatusSelect(value: any) {
    if (value.value == 2) { 
      this.HideClosed = "";
      this.addFormDecision.get('reason')?.setValidators([Validators.required]);
     } else { 
      this.HideClosed = "!isHidden";
      this.addFormDecision.get('reason')?.clearValidators();
    }
  }

  getMasterData() {
    this.getMaster('085', '').subscribe((data: any) => { this.Region = data; });
    // Section= 070
    this.getMaster('070', '').subscribe((data: any) => {
      this.SectionList = data;
    });
    // Currency= 115
    this.getMaster('115', '').subscribe((data: any) => {
      this.Currency = data;
    });
    // Product= 075
    this.getMaster('075', '').subscribe((data: any) => {
      this.ProductHelpList = data;
    });
    // 40 = Agency Record
    this.getMaster('040', '').subscribe((data: any) => {
      this.Agency = data;
    });
    // 10 = State Record
    this.getMaster('010', '').subscribe((data: any) => {
      this.State = data;
    });
    // 45= Category Record
    this.getMaster('045', '').subscribe((data: any) => {
      this.Category = data;
    });
    // 30= Department
    this.getMaster('030', '').subscribe((data: any) => {
      this.Department = data;
    });
    // 35= Designation
    this.getMaster('035', '').subscribe((data: any) => {
      this.Designation = data;
    });
    // 140= Designation
    this.getMaster('140', '').subscribe((data: any) => {
      this.typeOfAction = data;
    }); 
    /********** For Get Compant Master Name List ****** */
    this.http.get(this.url + 'Notice/GetCompanyMasterList').subscribe((data) => {
      this.Company = JSON.parse(data.toString());
    });
    /********** For Get Contact Manager Name ****** */
    this.http.get(this.url + 'GM/GetEmployee').subscribe((data) => {
      this.Manager = JSON.parse(data.toString());
    });

    /************For Get filling opposite party************* */
    this.http.get(this.url + 'Help/FetchHelpFillingOpposite')
      .subscribe((data) => {
        if (data == null) {
          this.FillingOppoParty = null;
        } else {
          this.FillingOppoParty = JSON.parse(data.toString());
          this.filteredFillingParty = [...this.FillingOppoParty];
          this.filteredOppositeParty = [...this.FillingOppoParty];
        }
      }
      );
  }
  getSysData(GID: string) {
    return this.http.get(this.url + 'SysData/GetSysData?GenID=' + GID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  // For Bind Field on Page Load Like  Company, Department, State, Agency, City
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  fetchNoticeCaseData() {
    this.http.get(this.url + 'CorporateDecision/Fetch_Existing_Notice_Planning?ID=' + this.id)
      .subscribe((data) => {
        if (data == null) {
          this.NoticeCaseData = null;
        }
        else {
          const fetchHeaderdata: Insertdecision = JSON.parse(data.toString())[0];
          console.log(fetchHeaderdata);
          this.getMaster('075', '').subscribe((data: any) => {
            this.SectionList = data;
            if (fetchHeaderdata.Product != null) {
              this.selectedProduct = fetchHeaderdata.Product.toString().split(',').map(Number);
            }
          });

          this.HeaderButtonCaptionValue = 0;
          this.HideClosed = "!isHidden";
          this.HeaderButtonCaption = "Update";
          if (fetchHeaderdata.Status == "1") {
            this.HideButtonSubmit = "";
            this.HeaderButtonCaption = "Re-Work";
            this.HeaderButtonCaptionValue = 1;
          }
          else if (fetchHeaderdata.Status == "2") {
            this.HideClosed = "";
            this.HideButtonSubmit = "";
            this.HeaderButtonCaption = "Re-Work";
            this.HeaderButtonCaptionValue = 1;
            this.addFormDecision.get('reason')?.setValidators([Validators.required]);
          }

          this.http.get(this.url + 'CorporateDecision/Fetch_PlanningStatus_Convert?PlanningID=' + this.id)
            .subscribe((data) => {
              if (data == null) {
                //this.FillingOppoParty = null;
                this.PageStatus = "";
              }
              else {

                this.PageStatus = "Note: Converted in Notice/Case Ref.No.(" + fetchHeaderdata.refno + ")";
                this.OutputValue = "Due to Converted in Notice/Case Ref.No.(" + fetchHeaderdata.refno + ")";
                this.addFormDecision.patchValue({ reason: this.OutputValue });
                this.HideButtonSubmit = "!isHidden";
                this.CaptionLabel = "Notice/Case Ref.No.";

              }
            }
            );
          //  this.http.get(this.url + 'Help/FetchHelpFillingOpposite')
          //  .subscribe( (data) =>   {
          //      if (data == null) {
          //        this.FillingOppoParty = null;
          //      } else {
          //        this.FillingOppoParty = JSON.parse(data.toString());

          if (fetchHeaderdata.FillingParty != null) {
            this.selectedFillingParty = fetchHeaderdata.FillingParty.toString().split(',').map(Number);
          }
          if (fetchHeaderdata.OppositeParty != null) {
            this.selectedOppositeParty = fetchHeaderdata.OppositeParty.toString().split(',').map(Number);
          }
          //      }
          //     }
          //  );
          if (fetchHeaderdata.NoticeRegion != null) {
            this.getMaster('090', fetchHeaderdata.NoticeRegion).subscribe((data: any) => { this.Branch = data; });
          }

          if (fetchHeaderdata.StateID != null) {
            this.getMaster('015', fetchHeaderdata.StateID.toString()).subscribe((data: any) => {
              this.City = data; /*let data1: any; this.Jurisdiction = data1;*/
            });
          }
          if (fetchHeaderdata.CityID != null) {
            this.getMaster('020', fetchHeaderdata.CityID.toString()).subscribe((data: any) => { this.Jurisdiction = data; });
          }
          if (fetchHeaderdata.CategoryID != null) {
            this.getMaster('050', fetchHeaderdata.CategoryID.toString()).subscribe((data: any) => { this.SubCategory = data; });
          }
          // tslint:disable-next-line: max-line-length
          if (localStorage.getItem('LoginUserID').toString() == fetchHeaderdata.ManagerID.toString()) {
            localStorage.setItem('Feedback', "");
            this.AddFollowupLink = "Add To Follow UP";
          }
          else if (localStorage.getItem('LoginUserID').toString() == (fetchHeaderdata.LeaderID == null ? "0" : fetchHeaderdata.LeaderID.toString())) {
            this.AddFollowupLink = "Add To Feedback";
            localStorage.setItem('Feedback', "Feedback");
          } // tslint:disable-next-line: max-line-length
          else {
            localStorage.setItem('Feedback', "");
            this.AddFollowupLink = "Add To Follow UP";
          }
          this.ManagerPreID = fetchHeaderdata.ManagerID;
          this.LeaderPreID = fetchHeaderdata.LeaderID;
          this.addFormDecision.patchValue({
            Region: fetchHeaderdata.NoticeRegion,
            Branch: fetchHeaderdata.NoticeBranch,
            ActionType: Number(fetchHeaderdata?.ActionType), ActionTakenBy: fetchHeaderdata.ActionTakenBy,
            reason: fetchHeaderdata.ReasonForClose, BriefFacts: fetchHeaderdata.facts,
            Agency: fetchHeaderdata.AgencyID, Description: fetchHeaderdata.Description,
            Manager: fetchHeaderdata.ManagerID,
            Category: fetchHeaderdata.CategoryID,
            SubCategory: fetchHeaderdata.SubCategoryID,
            ExposureAmmount: fetchHeaderdata.ExposureAmt,
            Company: fetchHeaderdata.CompanyID,
            Department: fetchHeaderdata.DeptID,
            State: fetchHeaderdata.StateID,
            TargetDate:  fetchHeaderdata.TargetDt,
            Leader: fetchHeaderdata.LeaderID,
            DueDate:  fetchHeaderdata.DueDt,
            DateofDecision: fetchHeaderdata.DateofDecision,
            City: fetchHeaderdata.CityID,
            Status: fetchHeaderdata.Status,
            Jurisdiction: fetchHeaderdata.CourtID,
            Currency: fetchHeaderdata.Currency,
            fillingPartyName: fetchHeaderdata.FillingParty?.split(',').map(Number),
            oppositePartyName: fetchHeaderdata.OppositeParty?.split(',').map(Number),
            HelpProduct: fetchHeaderdata.Product?.split(',').map(Number)
          });
        }
      }
      );
  }

  // receiveMessage(event) {
  //   let element: HTMLElement;
  //   element = document.getElementsByClassName('openModal')[0] as HTMLElement;
  //   element.click();
  // }
  receiveMessage = (event: MessageEvent) => {
    const element = document.getElementsByClassName('openModal')[0] as HTMLElement;
    if (element) {
      element.click();
    }
    window.removeEventListener('message', this.receiveMessage, false);
  };
  OpenModalData() {
    this.ModelFor = "Case/ Notice";
    this.HideCaseNotice = "";
  }
  onAddNoticeCaseorClosed(popupdata) {
    if (this.FormAddNoticeCaseorClosed.invalid) {
      this.FormAddNoticeCaseorClosed.markAllAsTouched();
      return;
    }
    // if (popupdata.Date == "") {
    //   this.alertService.showWarning(" Please add date ");
    //   // this.alertService.warn(" Please add date ", this.options);

    //   return;
    // } else if (popupdata.refno == "") {
    //   this.alertService.showWarning(" Please add reference no ");
    //   // this.alertService.warn(" Please add reference no ", this.options);
    //   return;
    // } else {
      let ConvertCaseNotice: IConvertCaseNotice = {
        ID: this.id,
        refno: popupdata.refno,
        Date: popupdata.Date,
        Status: this.statusNo,
      }
      this.http.post(this.url + 'CorporateDecision/PlanningToConvertNoticeCase', ConvertCaseNotice).subscribe((data) => {
        if (data == null) { this.alertService.error("' Some Error In Entered Record ", true); } else {
          this.alertService.showSuccess(`Successfully Converted to ${this.statusNo == 3 ? 'Notice' : 'Case'} `);
          // this.alertService.success(" Successfully Converted ", this.options);
          window.location.reload();
        }
      });
    // }
  }
  ConvertToNotice() {
    if (this.ManagerPreID != 0 || this.LeaderPreID != 0) {
      this.statusNo = 3;
      window.addEventListener("message", this.receiveMessage, false);
      parent.postMessage('message', document.location.href);
    } else {
      this.alertService.showWarning('Firstly Add Responsible Person or Responsible Leader');
      // this.alertService.warn('Firstly Add Responsible Person or Responsible Leader', this.options);
    }
  }

  ConvertToCase() {
    if (this.ManagerPreID != 0 || this.LeaderPreID != 0) {
      this.statusNo = 4;
      window.addEventListener("message", this.receiveMessage, false);
      parent.postMessage('message', document.location.href);
    } else {
      this.alertService.showWarning('Firstly Add Responsible Person or Responsible Leader');
      // this.alertService.warn('Firstly Add Responsible Person or Responsible Leader', this.options);
    }
  }
  // Save Decision
  onSubmit(HeaderFormData) {
    if(this.addFormDecision.invalid){ 
      this.addFormDecision.markAllAsTouched();
      return; 
    }

    if (HeaderFormData.Description == "") {
      this.alertService.showWarning('Please Enter Description');
      // this.alertService.warn('Please Enter Description', this.options);
      return;
    }

    if (HeaderFormData.BriefFacts == "") {
      this.alertService.showWarning("Please Enter Facts");
      // this.alertService.warn("Please Enter Facts", this.options);
      return;
    }
    if (HeaderFormData.ActionType == "") {
      this.alertService.showWarning("Please Enter Action Type");
      // this.alertService.warn("Please Enter Action Type", this.options);
      return;
    }

    if (HeaderFormData.TargetDate == "") {
      this.alertService.showWarning("Please Enter Target Date");
      //  this.alertService.warn("Please Enter Target Date", this.options);
      return;
    }
    if (HeaderFormData.DateofDecision == "") {
      this.alertService.showWarning("Please Enter Date of Decision");
      // this.alertService.warn("Please Enter Date of Decision", this.options);
      return;
    }

    if (this.datepipe.transform(HeaderFormData.TargetDate, "yyyy-MM-dd") < this.datepipe.transform(HeaderFormData.DateofDecision, "yyyy-MM-dd")) {
      this.alertService.showWarning("Please Target Date greater or equal to Date Of Decision");
      // this.alertService.warn("Please Target Date greater or equal to Date Of Decision", this.options);
      return;
    }

    if (this.datepipe.transform(HeaderFormData.DueDate, "yyyy-MM-dd") < this.datepipe.transform(HeaderFormData.DateofDecision, "yyyy-MM-dd")) {
      this.alertService.showWarning("Please Due Date greater or equal to Date Of Decision");
      // this.alertService.warn("Please Target Date greater or equal to Date Of Decision", this.options);
      return;
    }


    if (this.datepipe.transform(HeaderFormData.DueDate, "yyyy-MM-dd") < this.datepipe.transform(HeaderFormData.TargetDate, "yyyy-MM-dd")) {
      this.alertService.showWarning("Please Due Date greater or equal to Target Date");
      this.alertService.warn("Please Due Date greater or equal to Target Date", this.options);
      return;
    }


    if (HeaderFormData.ActionTakenBy == "") {
      this.alertService.showWarning("Please Enter Action Taken By");
      // this.alertService.warn("Please Enter Action Taken By", this.options);
      return;
    }
    if (HeaderFormData.Manager == 0) {
      this.alertService.showWarning('Please Select Responsible Person');
      // this.alertService.warn('Please Select Responsible Person', this.options);
      return;
    }
    if (HeaderFormData.Status == 2) {
      if (HeaderFormData.reason == "") {
        this.alertService.showWarning('Please Enter Reason For Closed');
        // this.alertService.warn('Please Enter Reason For Closed', this.options);
        return;
      }
    }


    if (this.addFormDecision.invalid) { return; } else {
      this.numb = 1;
      let decisionobj: Insertdecision = {
        id: this.id,
        fileSize: this.fileSize,
        fileBase: this.fileurls,
        fileName: this.fileName,
        facts: HeaderFormData.BriefFacts,
        ActionType: HeaderFormData.ActionType,
        ActionTakenBy: HeaderFormData.ActionTakenBy,
        Description: HeaderFormData.Description,
        TargetDt: HeaderFormData.TargetDate,
        DueDt: HeaderFormData.DueDate,
        DateofDecision: HeaderFormData.DateofDecision,
        CategoryID: HeaderFormData.Category,
        SubCategoryID: HeaderFormData.SubCategory,
        ExposureAmt: HeaderFormData.ExposureAmmount,
        CompanyID: HeaderFormData.Company,
        DeptID: HeaderFormData.Department,
        StateID: HeaderFormData.State,
        CityID: HeaderFormData.City,
        CourtID: HeaderFormData.Jurisdiction,
        AgencyID: HeaderFormData.Agency,
        ManagerID: HeaderFormData.Manager,
        LeaderID: HeaderFormData.Leader,
        Status: HeaderFormData.Status,
        recEnable: this.numb,
        recUser: this.numb,
        recAddUser: this.numb,
        FillingParty: HeaderFormData.fillingPartyName.toString(),
        OppositeParty: HeaderFormData.oppositePartyName.toString(),
        Product: HeaderFormData.HelpProduct.toString(),
        ReasonForClose: HeaderFormData.reason,
        NoticeID: "",
        refno: "",
        Rework: this.HeaderButtonCaptionValue,
        Currency: HeaderFormData.Currency,
        ManagerPreID: this.ManagerPreID,
        LeaderPreID: this.LeaderPreID,
        NoticeRegion: HeaderFormData.Region,
        NoticeBranch: HeaderFormData.Branch
      }
      this.http.post(this.url + 'CorporateDecision/InsertUpdateNoticePlanning', decisionobj).subscribe((data) => {
        if (data == null) {
          this.alertService.showError(' Some Error In Entered Record ');
          // this.alertService.error(' Some Error In Entered Record ', true); 
        } else {
          this.ManagerPreID = HeaderFormData.Manager;
          this.LeaderPreID = HeaderFormData.Leader;
          if (this.id == 0) {
            this.alertService.showSuccess('Decision Added Successfully ');
            // this.alertService.success('Decision Added Successfully', this.options);
          } else {
            this.alertService.showSuccess('Decision Updated Successfully ');
            // this.alertService.success('Decision Updated Successfully', this.options);
            // window.location.reload();
          }
          data = data.toString().split(':');
          this.getdata = data[1].toString().split('}');
          this.id = this.getdata[0].toString();
          this.HeaderButtonCaption = "Update";
          this.DisplayExistNotice = "";
          this.DisplaySaveNoticeButton = "submit";
          this.alertService.showConfirm('Do you want to fill further details?').then((confirmed) => {
            if (confirmed) {
              window.location.href = "corporate-decision/" + this.id;
            }
            else {
              window.close();
              //window.location.href = "#/nav/"+this.TypeHeader+"/0/update";
            }
          });
        }
      }
      );
    }
  }
  FetchDescisionHistory() {
    this.http.get(this.url + 'Notice/FetchNoticeHistory?NoticeID=' + this.id + '&Type=1')
      .subscribe((data) => {
        if (data == null) {
          this.fetchNoticeHistoryData = null;
        } else {
          this.fetchNoticeHistoryData = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }, (error) => {
        this.fetchNoticeHistoryDataError = true;
      }
      );
  }
  OpenModal1(url, cID, urld, modelName) {
    this.modalURL =  url + "/" + this.id + "/" + cID + "/" + "1";
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
  }
  OpenModal(url, cID, urld, modelName) {
    if (modelName == 'Evaluation Form') {
      this.modalURL =  url + "/" + this.id + "/" + cID;
      this.CallFunctionOnCloseModal = urld;
      this.ModelFor = modelName;
    }
  }

  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    this.fileSize = '';
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        let reader = new FileReader();
        reader.onload = (event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  AttachmentData() {
    this.loading = true;
    this.http.get(this.url + 'Notice/FetchDecisionAttachment?DecisionID=' + this.id + '&Type=1')
      .subscribe((data) => {
        this.loading = false;
        if (data == null) {
          this.factsheetDetail = null;
        } else {
          this.factsheetDetail = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }, (error) => {
        this.loading = false;
        this.factsheetDetailsError = true;
      }
      );
  }
  DeleteAttachment(FileID) {
    if (this.HideButtonSubmit == "!isHidden") {
      this.alertService.showError('You can not delete it');
      // this.alertService.error('You can not delete it', true);
    } else {
      this.alertService
        .showConfirm('Are you sure to delete it?')
        .then((confirmed) => {
          if (confirmed) {
            this.http.get(this.url + 'Notice/DeleteAttachment?ID=' + FileID)
              .subscribe((data) => {
                if (data == null) {
                  this.factsheetDetail = null; this.AttachmentData();
                } else {
                  this.alertService.showSuccess('Successfully Removed');
                  this.AttachmentData();
                }
              }
              );
          }
        })
    }
  }
  goBack() {
    this.router.navigate(['/plan/plan/0']);
  }
  updateFilters() {
    // Remove opposite party selections from filling party list
    this.filteredFillingParty = this.FillingOppoParty.filter(
      item => !this.selectedOppositeParty?.includes(item.ID)
    );

    // Remove filling party selections from opposite party list
    this.filteredOppositeParty = this.FillingOppoParty.filter(
      item => !this.selectedFillingParty?.includes(item.ID)
    );
  }
    onChequeBouncingUpdate(ChequeBouncingData) {
    if (this.ChequeBouncingForm.invalid) {
      this.ChequeBouncingForm.markAllAsTouched();
      return;
    }
    let ChequeBouncingobj: InsertChequeBouncingData = {
      id: this.id,
      AmtDue: ChequeBouncingData.AmountDue,
      ReceivingAmtDt: ChequeBouncingData.DateofReceivingAmount,
      Type: this.Type,
      ModePayment: ChequeBouncingData.ModeOfPayment,
      ChequeDt: ChequeBouncingData.ChequeDate,
      ChequeNo: ChequeBouncingData.ChequeNo,
      againstchequebouncing: ChequeBouncingData.againstchequebouncing,
      ReceivingAmt: ChequeBouncingData.ReceivingAmount,
      TotalOSFromParty: ChequeBouncingData.TotalOSFromParty,
      ChequeAmt: ChequeBouncingData.ChequeAmount,
      DishonorDt: ChequeBouncingData.DishonorDate,
      DishonorReason: ChequeBouncingData.DishonorReason,
      recEnable: this.numb,
      recUser: this.numb,
      recAddUser: this.numb,
      DishonorBank: ChequeBouncingData.DishonorBank,
      DishonorBankBranch: ChequeBouncingData.DishonorBankBranch
    };
    this.http.post(this.url + 'Notice/insertChequeBouncingData', ChequeBouncingobj).subscribe((data) => {
      this.clicked = false;
      if (data == null) {
        this.alertService.showError("Some Error In Entered Record");
      } else {
        if (this.id == 0) {
          this.alertService.showSuccess('Cheque Bouncing Data Added Successfully');
        } else {
          this.alertService.clear();
          this.alertService.showSuccess('Cheque Bouncing Data Updated Successfully');
        }
        data = data.toString().split(':');
        this.getdata = data[1].toString().split('}');
        this.id = this.getdata[0].toString();
      }
    }
    );
  }

  get c() { return this.ChequeBouncingForm.controls; }

  onChangeAmountDue(AmountDue) {
    this.AmountDue = AmountDue == '' ? 0 : AmountDue;
    this.againstchequebouncing = this.AmountDue - this.ReceivingAmount;
    this.ChequeBouncingForm.patchValue({ AmountDue: this.AmountDue, ReceivingAmount: this.ReceivingAmount, againstchequebouncing: this.againstchequebouncing });
  }
  onChangeReceivingAmount(ReceivingAmount) {
    this.ReceivingAmount = ReceivingAmount == '' ? 0 : ReceivingAmount;
    this.againstchequebouncing = this.AmountDue - this.ReceivingAmount;
    this.ChequeBouncingForm.patchValue({ AmountDue: this.AmountDue, ReceivingAmount: this.ReceivingAmount, againstchequebouncing: this.againstchequebouncing });
  }
}
